"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = {
    /** Action that gets dispatched when a request to create a room is sent */
    CREATE_DISPLAY_DEVICE_REQUEST: 'CREATE_DISPLAY_DEVICE_REQUEST',
    /** Action that gets dispatched when a request to create a room is succesful */
    CREATE_DISPLAY_DEVICE_SUCCESS: 'CREATE_DISPLAY_DEVICE_SUCCESS',
    /** Action that gets dispatched when a request to create a room is not succesful */
    CREATE_DISPLAY_DEVICE_FAILURE: 'CREATE_DISPLAY_DEVICE_FAILURE',
    GET_DISPLAY_DEVICE_INFO_FAILED: 'GET_DISPLAY_DEVICE_INFO_FAILED',
    GET_DISPLAY_DEVICE_INFO_SUCCESS: 'GET_DISPLAY_DEVICE_INFO_SUCCESS',
    GET_CIPHER_SUCCESS: 'GET_CIPHER_SUCCESS',
    GET_CIPHER_FAILED: 'GET_CIPHER_FAILED',
    /** Action that gets dispatched when a device gets its login JWT succesfully */
    GET_DEVICE_LOGIN_SUCCESS: 'GET_DEVICE_LOGIN_SUCCESS',
    /** Action that gets dispatched when a device it fails to get its login JWT succesfully */
    GET_DEVICE_LOGIN_FAILED: 'GET_DEVICE_LOGIN_FAILED',
    /** Action that gets dispatched when data is received from the 'ls.pairing' subscription */
    WAMP_SUBSCRIPTION_LINKING_EVENT: 'WAMP_SUBSCRIPTION_LINKING_EVENT',
    /** Actions relating to the linking/unlinking relationship between the display & remote (tablet) */
    REMOTE_LINKED: 'REMOTE_LINKED',
    REMOTE_UNLINK_BEGIN: 'REMOTE_UNLINK_BEGIN',
    REMOTE_UNLINK_SUCCESS: 'REMOTE_UNLINK_SUCCESS',
    REMOTE_UNLINK_FAILED: 'REMOTE_UNLINK_FAILED',
    RESET_PAIRING_STATE: 'RESET_PAIRING_STATE',
    GET_PRESENTER_TOKEN_FAILED: 'GET_PRESENTER_TOKEN_FAILED',
    GET_PRESENTER_TOKEN_SUCCESS: 'GET_PRESENTER_TOKEN_SUCCESS',
    /** Action that gets dispatched when a linking code is generated for the remote (or the presenter) */
    GENERATE_LINKING_CODE_REQUEST: 'GENERATE_LINKING_CODE_REQUEST',
    GENERATE_LINKING_CODE_SUCCESS: 'GENERATE_LINKING_CODE_SUCCESS',
    GENERATE_LINKING_CODE_FAILURE: 'GENERATE_LINKING_CODE_FAILURE',
    /** manually set the lremote linking code (same action for tablet and presenter linking) */
    SET_LINKING_CODE: 'SET_LINKING_CODE',
    DISPLAY_PAIRED: 'DISPLAY_PAIRED',
    DISPLAY_UNPAIRED: 'DISPLAY_UNPAIRED',
    REQUEST_PIN_CHANGE: 'REQUEST_PIN_CHANGE',
    SET_LOCAL_PIN: 'SET_LOCAL_PIN'
};
// payload eventTypes received from css for ls.pairing
exports.subscriptionEventTypes = {
    /* we get the same eventType from css for either 'unpair' or 'delete' from the admin console. From the point of view
     * of the display/presenter(s)/tablet it is irrelevant at this time which was triggered since they will all log out
     * and assume their initial states (ready to create/pair with a room) */
    unpaired: 'DEVICE_INFO_DELETE',
    /* This event is only received by the tablet when an 'unlink' is initiated by the tablet. */
    unlinked: 'DEVICE_UNLINKED',
    licenseUpdate: 'DEVICE_LICENSE_UPDATE',
    /* This event is received by all clients in the group when any tablet in the same group is successfully linked. */
    linked: 'DEVICE_LINKED',
    /* This event is received by the client whenever it requests a new pairing code. */
    pairingCodeCreate: 'DEVICE_PAIRING_CODE_CREATE',
    /* This event is received by the client whenever the pairing code is refreshed and a new one is issued. */
    pairingCodeUpdate: 'DEVICE_PAIRING_CODE_UPDATE'
};
// the license statuses returned from checkin service
exports.licenseStatus = {
    inactive: 'INACTIVE',
    paid: 'PAID',
    trial: 'TRIAL'
};
exports.deviceInfoService = {
    name: 'lifesize.deviceInfo',
    actions: {
        // uriSuffix
        create: 'device/create',
        delete: 'device/delete',
        get: 'device/get',
        list: 'device/list',
        update: 'device/update'
    }
};
exports.devicePairingService = {
    name: 'lifesize.devicePairing',
    actions: {
        // uriSuffix
        check: 'pairing/checkname',
        create: 'pairing/create',
        createShared: 'pairing/createshared',
        delete: 'pairing/delete',
        deleteList: 'pairing/deletelist',
        generate: 'pairing/generate',
        get: 'pairing/getdevices',
        getDetails: 'pairing/accountdetails',
        unlink: 'pairing/unlink',
        update: 'pairing/update'
    },
    url: {
        stage: 'https://galapi.lifesizecloudbeta.com/device/link/',
        prod: 'https://galapi.lifesizecloud.com/device/link/'
    }
};
exports.loginService = {
    grantType: 'graphite',
    url: {
        stage: 'https://login.lifesizecloudbeta.com/ls/token/',
        prod: 'https://login.lifesizecloud.com/ls/token/'
    }
};
exports.topics = {
    pairingTopic: 'ls.pairing'
};
exports.linkedDeviceTypes = {
    presenter: 'graphite-presenter',
    tablet: 'graphite-tablet',
    gemsTablet: 'gems-tablet'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/constants/pairing.js
// module id = 62
// module chunks = 0